import { PropsWithChildren } from 'react';

import * as S from './style';

export interface AsideCardProps {
  noPadding?: boolean;
}

export default function AsideCard({
  children,
  noPadding,
  ...props
}: PropsWithChildren<AsideCardProps>) {
  return (
    <S.Wrapper noPadding={noPadding} {...props}>
      {children}
    </S.Wrapper>
  );
}
